import { createContext } from "react";

export const DisableActionContext = createContext('');